import React from 'react';

const FastDevService = ({ data }) => {
  return (
    <section className="p-80px-tb fast-dev-service">
      <div className="container">
        <div className="row">
          <div className="col-md-12 m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
            <p className="lead text-primary font-weight-bold m-20px-b">{data.lead}</p>
            <p className="text-muted">{data.content}</p>
          </div>
        </div>

        {/* 4つの経営メリット */}
        <div className="row m-50px-t">
          <div className="col-md-12 m-30px-b">
            <h3 className="h3 font-weight-bold">{data.benefitsTitle}</h3>
          </div>
          {data.benefits.map((benefit, index) => (
            <div key={index} className="col-lg-6 m-30px-b">
              <div className="benefit-card p-30px bg-light rounded h-100">
                <div className="d-flex align-items-start">
                  <div className="benefit-icon m-20px-r">
                    <i className={`${benefit.icon} icofont-3x text-primary`}></i>
                  </div>
                  <div className="benefit-content">
                    <h4 className="font-weight-bold m-15px-b">{benefit.title}</h4>
                    <p className="text-muted m-0">{benefit.content}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 具体的な活用シーン */}
        <div className="row m-50px-t">
          <div className="col-md-12 m-30px-b">
            <h3 className="h3 font-weight-bold">{data.useCasesTitle}</h3>
          </div>
          {data.useCases.map((useCase, index) => (
            <div key={index} className="col-lg-4 col-md-6 m-30px-b">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title font-weight-bold">{useCase.title}</h5>
                  <p className="card-text text-muted">{useCase.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FastDevService;